import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

import SubHeader from "./SubHeader";
import FormInput from "../forms/FormInput";
import { setLoading } from "../../actions/authAction";
import history from "../../history";
import api from "../../api/api";
import uri from "../../variables/uri";
import AlertModal from '../modals/AlertModal';
import RequestDetailModal from '../modals/RequestDetailModal';
import ActionModal from '../modals/ActionModal';
import HistoryModal from '../modals/HistoryModal';
import EditNoteModal from '../modals/EditNoteModal';
import ReactExport from "react-data-export";
import Pagination from 'rc-pagination';
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class SearchRequest extends React.Component {
  state = {
    name: this.props.user.userID,
    user: this.props.user,
    isOpenMessage: false,
    isOpenHistory: false,
    isOpenConfirm: false,
    isOpenDetail:false,
    type:1,
    message: "",
    text: "",
    requestNo: "",
    dataList:[],
    currentPage: 1,
    postsPerPage: 15,
    detailList:[],
    permissionList:[],
    isOpenGroup:false,
    bookName:'',
    isDownloadExcel:false,
    excelDataList:[],
    excelRequestId:'',
    excelRequestNo:'',
    excelRequestDate:'',
    excelRequestUserId:'',
    isOpenAction:false,
    action:'',
    actionId:'',
    actionCreatorID:'',
    historyList:[],
    fileName:'',
    isOpenEditNote: false,
    note: '',
    noteId:'',
    isShowDetail:true,
    errorMsg: ''
  };

  componentDidMount = async () => { 
    if (!this.props.auth.isAuthen || (!this.props.auth.isAdmin && !this.props.auth.isEditor && !this.props.auth.isApprover)) {
      history.push(`/home/${localStorage.getItem('username')}`)
    }
    else {
     this.onSearch();
    }
  };
 
  onRequestNoChange = (val) => {
    this.setState({ requestNo:val});
  };

  onSearch = async () => {
    this.props.setLoading(true);
    this.setState({
      dataList: [],
    });
    try{
      const groupResponse = await api.get(
        `${uri.GET_SEARCH_REQUEST}?search=${this.state.requestNo}&user=${localStorage.getItem('username')}&type=${this.props.match.params.type}&isAdmin=${this.props.auth.isAdmin}&isEditor=${this.props.auth.isEditor}&isApprover=${this.props.auth.isApprover}`
      );
    if (groupResponse.status === 200) {
        this.setState({
          dataList: groupResponse.data,
          currentPage:1
        });
        if(this.props.match.params.id!==undefined && this.props.match.params.id!==null&&this.props.match.params.id!=='' && this.state.isShowDetail)  {
          this.onDetail(this.props.match.params.id);
          this.setState({isShowDetail: false});
        }
        
        this.props.setLoading(false);
      }
    }catch(ex){
      this.setState({
        dataList: [],
      });
      this.props.setLoading(false);
    }
    
  };

  onDetail = async (id) => {
    this.props.setLoading(true);
    try{
      var response = await api.get(
        `${uri.GET_REQUEST_DETAIL}?id=${id}`
      );
      if(response.status === 200){
        
        const permis = await api.get(`${uri.GET_PERMISSION_LIST}?PermissionGroupID=${ response.data.PermissionGroupId}`);
        const permissionArr = [];
        permis.data.forEach(element => {
            permissionArr.push(element.PermissionName !== null ? element.PermissionName : element.PermissionValue);
        });
        let permissionSelection = permissionArr;
        permissionSelection.push('Please select');
        permissionSelection = permissionSelection.reverse();
        this.setState({errorMsg: response.data.ErrorMsg, isOpenDetail:true,detailList:response.data.Details, bookName: response.data.BookName , permissionList:_.sortBy(permis.data, 'PermissionSequence').reverse()});
        this.props.setLoading(false);
      }
    }catch(ex){
      console.log(ex);
      this.setState({isOpenDetail:false,detailList:[],isOpenMessage: true, message:"Data not found.", type:3, errorMsg:''});
      this.props.setLoading(false);
    }
  }

  displayNote=(txt)=>{

    if(txt !== null && txt !== undefined && txt !== ""){
      if(txt.length > 20){
        txt = txt.substring(0, 20)+"...";
      }
      return (<span>{txt}</span>)
    }
    return (<span>...</span>)
  }


  onEditNote=(item)=>{
    let txt = item.Note;
    if(txt === null || txt === undefined){
      txt = "";
    }
    let newList = this.state.dataList.map((obj)=>{
      if(item.RequestID === obj.RequestID){
        obj.IsChecked = true;
      }
      return obj;
    })
    this.setState({note: txt, noteId: item.RequestID, dataList: newList});
  }
  onCloseItem=()=>{
    let newList = this.state.dataList.map((obj)=>{
      obj.IsChecked = false;
      return obj;
    })
    this.setState({dataList: newList});
  }

  onSubmitNote=async(txt)=>{
    this.onCloseItem();
    this.props.setLoading(true);
    try{
      var obj = {
        RequestID:this.state.noteId,
        Note:txt,
        UserId:localStorage.getItem('username')
      }
      var response = await api.post(`${uri.POST_UPDATE_NOTE}`,obj);
      if(response.status === 200){
        this.setState({ isOpenMessage: true, message:'The note has been updated successfully.', type:1});
        this.props.setLoading(false);
        this.onSearch();
      }

    }catch(ex){
      this.setState({ isOpenMessage: true, message:'An error has occurred.', type:3});
      this.props.setLoading(false);
    }
  }

  onClose = () =>{
    this.setState({ isOpenDetail: false, isOpenMessage: false, isOpenConfirm:false, isOpenAction:false, isOpenHistory: false, isOpenEditNote:false});
  }

  onHistory = async (id)=>{
    this.props.setLoading(true);
    try{
      var response = await api.get(
        `${uri.GET_HISTORY}?id=${id}`
      );
    if(response.status === 200){
      this.setState({ isOpenHistory:true, historyList: response.data});
      this.props.setLoading(false);
    }
    }catch(ex){
      this.setState({isOpenHistory:false,historyList:[]});
      this.props.setLoading(false);
    }
  }

  onAction =(id,act,createid)=>{
    this.setState({ actionId:id, action: act, isOpenAction:true, actionCreatorID: createid});
  }
  onConfirmAction = async (txt)=>{
    this.onClose();
    this.props.setLoading(true);
    try{
      var obj = {
        RequestID:this.state.actionId,
        Action:this.state.action,
        Reason:txt,
        UserId:localStorage.getItem('username'),
        CreatorID: this.state.actionCreatorID
      }
      var response = await api.post(`${uri.POST_ACTION}`,obj);
      if(response.status === 200){
        this.setState({ isOpenMessage: true, message:'The request has been '+this.state.action, type:1});
        this.props.setLoading(false);
        this.onSearch();
      }

    }catch(ex){
      this.setState({ isOpenMessage: true, message:'An error has occurred.', type:3});
      this.props.setLoading(false);
    }
  }

  convertNullToStringEmpty(str){
    if(str === undefined || str === null){
        return "";
    }else{
        return str;
    }
  } 
  onDownloadCheckin= async (id,rno,rdate,ruser)=>{
    this.setState({ isDownloadExcel:false});
    this.props.setLoading(true);
    try{
      var response = await api.get(
        `${uri.GET_REQUEST_DETAIL}?id=${id}`
      );
    if(response.status === 200){
      this.setState({ excelDataList:response.data.Details,excelRequestId:id,excelRequestDate:rdate,excelRequestNo:rno,fileName:rno+'_Checkin',excelRequestUserId:ruser});
      this.setState({ isDownloadExcel:true});
      this.props.setLoading(false);
    }
    }catch(ex){
      this.setState({isDownloadExcel:false,excelDataList:[]});
      this.setState({ isDownloadExcel:true,excelRequestId:id,excelRequestDate:rdate,excelRequestNo:rno,fileName:rno+'_Checkin',excelRequestUserId:ruser});
      this.props.setLoading(false);
    }
  }
  onDownload= async (id,rno,rdate,ruser)=>{
    this.setState({ isDownloadExcel:false});
    this.props.setLoading(true);
    try{
      var response = await api.get(
        `${uri.GET_REQUEST_DETAIL_EXCEL}?id=${id}`
      );
    if(response.status === 200){
      this.setState({ excelDataList:response.data,excelRequestId:id,excelRequestDate:rdate,excelRequestNo:rno,fileName:rno+'_Checkout',excelRequestUserId:ruser});
      this.setState({ isDownloadExcel:true});
      this.props.setLoading(false);
    }
    }catch(ex){
      this.setState({isDownloadExcel:false,excelDataList:[]});
      this.props.setLoading(false);
    }
  }
  downloadExcelForEdit() {
    let filename = 'DOA ' +this.state.fileName;
    let multiDataSet =[{
        columns: [
            {title: "RequestNo", width: {wpx: 90}},
            {title: "RequestID", width: {wpx: 90}},
            {title: "RequestDate", width: {wpx: 90}},
            {title: "RequestUserId", width: {wpx: 90}},
        ],
        data:[
            [
                {value: this.state.excelRequestNo},
                {value: this.state.excelRequestId},
                {value: this.state.excelRequestDate},
                {value: this.state.excelRequestUserId}
            ],
            [
                {value: "ReferenceID", style: {font: {bold: true}}},
                {value: "Action", style: {font: {bold: true}}},
                {value: "Book", style: {font: {bold: true}}},
                {value: "Subject", style: {font: {bold: true}}},
                {value: "SubjectTypeCode", style: {font: {bold: true}}},
                {value: "SubjectType", style: {font: {bold: true}}},
                {value: "TopicNo", style: {font: {bold: true}}},
                {value: "TopicTitle", style: {font: {bold: true}}},
                {value: "ConditionTitle", style: {font: {bold: true}}},
                {value: "Type", style: {font: {bold: true}}},
                {value: "Operation", style: {font: {bold: true}}},
                {value: "Value", style: {font: {bold: true}}},
                {value: "ApproveLevel", style: {font: {bold: true}}},
                {value: "ApproveLevelText", style: {font: {bold: true}}},
                {value: "SignLevel", style: {font: {bold: true}}},
                {value: "SignLevelText", style: {font: {bold: true}}},
                {value: "ReportLevel", style: {font: {bold: true}}},
                {value: "ReportLevelText", style: {font: {bold: true}}},
                {value: "Remark", style: {font: {bold: true}}},
                {value: "Comment", style: {font: {bold: true}}}
            ]
        ]    
    }];
    this.state.excelDataList.map((obj)=>{
        let arr = [
            {value:obj.ReferenceID === null?'': obj.ReferenceID},
            {value:obj.Action},
            {value:this.convertNullToStringEmpty(obj.Book)},
            {value:this.convertNullToStringEmpty(obj.SubjectTitle)},
            {value:this.convertNullToStringEmpty(obj.SubjectTypeID)},
            {value:this.convertNullToStringEmpty(obj.SubjectTypeTitle)},
            {value:this.convertNullToStringEmpty(obj.TopicNo)},
            {value:this.convertNullToStringEmpty(obj.TopicTitle)},
            {value:this.convertNullToStringEmpty(obj.ConditionTitle)},
            {value:this.convertNullToStringEmpty(obj.Type)},
            {value:this.convertNullToStringEmpty(obj.Operation)},
            {value:this.convertNullToStringEmpty(obj.Value)},
            {value:this.convertNullToStringEmpty(obj.Approve)},
            {value:this.convertNullToStringEmpty(obj.ApproveText)},
            {value:this.convertNullToStringEmpty(obj.Sign)},
            {value:this.convertNullToStringEmpty(obj.SignText)},
            {value:this.convertNullToStringEmpty(obj.Report)},
            {value:this.convertNullToStringEmpty(obj.ReportText)},
            {value:this.convertNullToStringEmpty(obj.Remark)},
            {value:this.convertNullToStringEmpty(obj.Comment)}
        ];
        multiDataSet[0].data.push(arr);
    });

  return (
    <ExcelFile hideElement={true} filename={filename}>
            <ExcelSheet dataSet={multiDataSet} name="Doa"/>
        </ExcelFile>
  );
}
onShowSizeChange = (current, pageSize) => {
  this.setState({ currentPage:current });
}

goHome = () =>{
  history.push(`/home/${localStorage.getItem('username')}`);
}

  render() {
    const indexOfLastPost = this.state.currentPage * this.state.postsPerPage;
    const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
    const currentPosts = this.state.dataList.slice(indexOfFirstPost, indexOfLastPost);
    return (
      <div className="home flex-v">
        <SubHeader text={`${this.props.match.params.type}`} goTo={this.goHome}/>
          <div className="flex-v flex-1">
            <div className="flex-v flex-1 pl-24 pr-24">
              <div
                className="flex-v bg-grey-lighter pl-16 pr-16 pb-16 mt-16"
                style={{ borderRadius: "10px" }}
              >
                <FormInput
                  value={this.state.requestNo}
                  onValueChange={this.onRequestNoChange}
                  type="text"
                  placeholder="Request No"
                />
                  <div className=" flex-h mt-16 center buttons" >
                      <button onClick={() => this.onSearch()} className="button is-success center" >
                          Search
                      </button>
                      {/* {((this.props.auth.isEditor || this.props.auth.isAdmin) && this.props.match.params.type === 'Inbox') && 
                      <button  onClick={() => history.push(`/Upload/Doa`)} className="button is-info center" >
                          Checkin
                      </button>} */}
                  </div>
              </div>
            </div>
          </div>
        <div className="flex-v text-center p-16 mt-8">
            {this.state.dataList.length === 0 ?<div>Data not found.</div>:
              <div className="table-container">
                <table className="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
                    <thead>
                        <tr>
                            <th>
                                #
                            </th>
                            <th>
                                Request No
                            </th>
                            <th style={{width: '150px'}}>
                                Note
                            </th>
                            <th>
                                Status
                            </th>
                            <th>
                                Creator
                            </th>
                            <th style={{width: '100px'}}>
                                Create date
                            </th>
                            <th style={{width: '89x'}}>
                                Expired date
                            </th>
                            <th style={{width: '210px'}}>
                                Detail
                            </th>
                            <th>
                                Action
                            </th> 
                            <th style={{width: '70px'}}>
                              History
                            </th>
                        </tr>
                        </thead>
                        <tfoot>
                        <tr>
                            <td colSpan="10" style={{textAlign:'center'}}>
                            <Pagination className="ant-pagination" 
                              onChange={this.onShowSizeChange}
                              defaultCurrent={1} 
                              pageSize={this.state.postsPerPage} 
                              total={this.state.dataList.length} />
                            </td>
                        </tr>
                        </tfoot>
                        <tbody>
                            {currentPosts.map((item, i) =>{
                                return (
                                    <tr key={item.RequestID}>
                                        <td>
                                            {i+1}
                                        </td>
                                        <td>{item.RequestNo}</td>
                                        <td>
                                          {item.CreatorID.toString().toLowerCase() !== localStorage.getItem('username').toString().toLowerCase() && <span>{item.Note}</span>}
                                          {item.CreatorID.toString().toLowerCase() === localStorage.getItem('username').toString().toLowerCase() && 
                                          <span className={`note-detail`} onClick={()=>this.onEditNote(item)} >{item.Note}</span>}
                                          {/* <span className={`note-detail`} onClick={()=>this.onEditNote(item)} >{this.displayNote(item.Note)}</span>} */}
                                          <EditNoteModal isOpen={item.IsChecked} onConfirm={this.onSubmitNote} onClose={this.onCloseItem} text={item.Note==null|| item.Note === undefined ?'':item.Note} />
                                        </td>
                                        <td>{item.StatusName}</td>
                                        <td>{item.CreatorName}</td>
                                        <td>{item.CreateDateDisplay}</td>
                                        <td>{item.DisplayExpireDate}</td>
                                        <td>
                                          {item.IsCheckin &&
                                            <div>
                                              <button className="button is-small is-info is-outlined" onClick={() => this.onDetail(item.RequestID)}>View</button>
                                              <button onClick={() => this.onDownloadCheckin(item.RequestID,item.RequestNo,item.CreateDateDisplay,item.CreatorID)} className="button is-small is-default is-outlined ml-8">Download checkin</button>
                                            </div>
                                          }
                                          {/* {(item.StatusCode != 'create') && 
                                          <button className="button is-small is-info is-outlined" onClick={() => this.onDetail(item.RequestID)}>View</button>}
                                          {(item.StatusCode != 'create') && 
                                          <button onClick={() => this.onDownloadCheckin(item.RequestID,item.RequestNo,item.CreateDateDisplay,item.CreatorID)} className="button is-small is-default is-outlined ml-8">Download checkin</button>} */}
                                        </td>
                                        <td>
                                          {(this.props.match.params.type === 'Inbox' && item.StatusCode === 'wait_approve' && (this.props.auth.isApprover || this.props.auth.isAdmin)) &&
                                              <button onClick={() => this.onAction(item.RequestID, 'approve', item.CreatorID)} className="button is-small is-info is-outlined">Approve</button>
                                          }
                                          {(this.props.match.params.type === 'Inbox' && item.StatusCode === 'wait_approve' && (this.props.auth.isApprover || this.props.auth.isAdmin)) &&
                                              <button onClick={() => this.onAction(item.RequestID, 'reject', item.CreatorID)} className="button is-small is-danger is-outlined ml-8">Reject</button>
                                          }

                                          {(this.props.match.params.type === 'Inbox' && item.StatusCode === 'create' && (this.props.auth.isEditor || this.props.auth.isAdmin)) &&
                                              <button onClick={() => this.onAction(item.RequestID, 'cancel', item.CreatorID)} className="button is-small is-danger is-outlined ml-8">Cancel</button>
                                          }
                                          {(this.props.match.params.type === 'Inbox' && item.StatusCode === 'create' && (this.props.auth.isEditor || this.props.auth.isAdmin)) &&
                                              <button onClick={() => history.push(`/Upload/Doa/${item.RequestID}`)} className="button is-small is-info is-outlined ml-8">Checkin</button>
                                          }

                                          {(this.props.match.params.type === 'History' && item.StatusCode === 'wait_approve' && (this.props.auth.isEditor || this.props.auth.isAdmin)) &&
                                              <button onClick={() => this.onAction(item.RequestID, 'withdraw', item.CreatorID)} className="button is-small is-danger is-outlined ml-8">Withdraw</button>
                                          }
                                          
                                          <button onClick={() => this.onDownload(item.RequestID,item.RequestNo,item.CreateDateDisplay,item.CreatorID)} className="button is-small is-default is-outlined ml-8">Download checkout</button>
                                        </td>
                                        <td>
                                          <button onClick={() => this.onHistory(item.RequestID)} className="button is-small is-warning is-outlined">View</button>
                                        </td>
                                    </tr>
                                );
                            })}
                        
                    </tbody>
                </table>
              </div>
            }
          
        </div>
        <AlertModal isOpen={this.state.isOpenMessage} message={this.state.message} onClose={this.onClose} type={this.state.type} />
        <HistoryModal isOpen={this.state.isOpenHistory} onClose={this.onClose} datas={this.state.historyList} />
        <ActionModal isOpen={this.state.isOpenAction} action={this.state.action} onClose={this.onClose} actionId={this.state.actionId} onConfirm={this.onConfirmAction}/>
        
        <RequestDetailModal isOpen={this.state.isOpenDetail} onClose={this.onClose} bookName={this.state.bookName} data={this.state.detailList} permissionList={this.state.permissionList} errMsg={this.state.errorMsg} />
        {this.state.isDownloadExcel && this.downloadExcelForEdit()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    user: state.doa.user,
  };
};

export default connect(mapStateToProps, {
  setLoading,
})(SearchRequest);
